<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 64 64"
  >
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M8.427 2.16h47.147c4.64 0 8.427 3.514 8.427 7.858v43.968c0 4.327-3.768 7.856-8.427 7.856H8.427C3.787 61.84 0 58.33 0 53.985V9.997C0 5.673 3.765 2.16 8.427 2.16"
                fill="#5468ff"
                transform="translate(1)"
              />
              <path
                d="M38.67 15.482v-2.047c-.001-1.43-1.245-2.6-2.78-2.6h-6.477c-1.534 0-2.777 1.158-2.78 2.6v2.1c0 .234.232.398.485.343 1.832-.493 3.73-.743 5.637-.74a21.96 21.96 0 0 1 5.445.686c.235.055.467-.107.467-.343m-17.75 2.68L19.8 17.13a2.88 2.88 0 0 0-1.964-.76c-.737 0-1.443.273-1.964.76l-1.323 1.23c-.522.484-.816 1.142-.816 1.83s.294 1.345.816 1.83l1.088 1.015c.176.162.43.124.584-.037.642-.822 1.35-1.597 2.12-2.318.776-.726 1.614-1.4 2.507-2 .194-.1.213-.363.06-.527m11.82 6.498v8.853c0 .254.293.435.544.308l8.44-4.073c.192-.1.25-.308.155-.487-1.75-2.862-4.997-4.817-8.75-4.944-.195 0-.4.144-.4.343m0 21.326c-7.037 0-12.755-5.324-12.755-11.877S25.7 22.234 32.738 22.234s12.755 5.322 12.755 11.874-5.696 11.877-12.755 11.877m0-28.747c-9.995 0-18.1 7.55-18.1 16.87s8.107 16.855 18.1 16.855 18.1-7.55 18.1-16.873-8.088-16.853-18.1-16.853"
                fill="#fff"
                transform="translate(1)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'AlgoliaLogo',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
